import { useEffect } from "react";
import { useQuery, useSubscription } from "@apollo/client";
import { useDispatch } from "react-redux";
import {
  QUERY_RESS_PIT_BOOST_ENERGY_ADJUSTMENTS,
  QUERY_RESS_TRACES,
  SUBSCRIBE_RESS_TRACE_UPDATE,
} from "../queries/ressQueries";
import { setRessTraces, updateRessTraces } from "../../../state/ressReducer";
import { RessPitBoostEnergyAdjustments } from "../../../types/ress";

export function useQueryRessPitBoostEnergyAdjustments(
  strategyImportId: string | null,
  strategyImportDt: number | null,
) {
  return useQuery<{
    getRessPitBoostEnergyAdjustments: RessPitBoostEnergyAdjustments;
  }>(QUERY_RESS_PIT_BOOST_ENERGY_ADJUSTMENTS, {
    variables: { strategyImportId: strategyImportId ?? "", strategyImportDt },
    skip: !strategyImportId,
    fetchPolicy: "no-cache",
    context: { skipRetry: true },
  });
}

export function useQueryRessTraces() {
  const dispatch = useDispatch();
  const { data, error } = useQuery(QUERY_RESS_TRACES);

  useEffect(() => {
    if (data) {
      dispatch(setRessTraces(data.getRaceData));
    }
  }, [dispatch, data]);

  if (error) {
    console.log(error);
  }
}

export function useSubscribeRessTraceUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_RESS_TRACE_UPDATE, {
    onData: (x) => {
      dispatch(updateRessTraces(x.data.data.newLapTableUpdate));
    },
  });

  if (error) {
    console.log(error);
  }
}
